/* eslint-disable import/prefer-default-export */
/**
 * Logger
*/

const Logger = {
  log: (message?: any, ...optionalParams: any[]) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.log(message, optionalParams);
    }
  },
  warn: (message?: any, ...optionalParams: any[]) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.warn(message, optionalParams);
    }
  },
  error: (message?: any, ...optionalParams: any[]) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      console.error(message, optionalParams);
    }
  },
};

export {
  Logger,
};
